import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { KindsModalComponent } from '../../layout/kindsmodal/kindsmodal.component';
var ChangeListComponent = (function () {
    function ChangeListComponent(_data, _blogic) {
        this._data = _data;
        this._blogic = _blogic;
    }
    ChangeListComponent.prototype.openKindModal = function () {
        this.kindsModal.openKindModal("atypesListModal");
    };
    return ChangeListComponent;
}());
export { ChangeListComponent };
